export enum ClauseType {
  EvisortAI = 'Evisort AI',
  Migrated = 'Migrated',
  QuickAI = 'Quick AI',
}
